module.exports = __webpack_public_path__ + "static/media/weather.4df1aa54.png";